import React from "react";
import { STATUS_LABELS, STATUS_CLASS } from "../lib/api";

export default function StatusBadge({ status }) {
  const cls = STATUS_CLASS[status] || "status-draft";
  const label = STATUS_LABELS[status] || status;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}
